import { useMemo } from 'react';
import { useGetBuildingPackageQuery } from '../api';
/**
 * Hook to get a building package for a specific id.
 *
 * @param projectId the project id that the package belongs to.
 * @param buildingPackageId the building package id to fetch.
 *
 * @returns an object with a building package, loading state, error state and error object.
 */
export const useBuildingPackage = (projectId, buildingPackageId) => {
    const { data: buildingPackage, isLoading, isError, error, } = useGetBuildingPackageQuery({
        projectId,
        buildingPackageId,
    });
    return useMemo(() => ({
        buildingPackage,
        isLoading,
        isError,
        error,
    }), [buildingPackage, error, isError, isLoading]);
};
